jQuery(document).ready(function($) {

    const $contactForm = $('#contact-form');
    const $submitBtn = $contactForm.find('#contact-submit');
    const $errorNotice = $('#error-notice');

    sendContactEmail($, $contactForm, $submitBtn, $errorNotice);

});

function sendContactEmail($, $contactForm, $submitBtn, $errorNotice) {
    $submitBtn.on('click',function(e){
        e.preventDefault();
        // do request for recaptcha token
        // response is promise with passed token
        grecaptcha.ready(function() {
            grecaptcha.execute(ContactFormLocalizedData.captchaSiteKey, {action: 'contact'}).then(function(token) {

                $contactForm.prepend('<input type="hidden" id="recaptcha" name="g-recaptcha-response" value="' + token + '">');
                
                const postData = {
                    action: 'send_email',
                    lastName : $contactForm.find('#last-name').val(),
                    firstName : $contactForm.find('#first-name').val(),
                    email : $contactForm.find('#email').val(),
                    tel : $contactForm.find('#tel').val(),
                    function : $contactForm.find('#function').val(),
                    company : $contactForm.find('#company').val(),
                    employees : $contactForm.find('#employees').find(":selected").val(),
                    message : $contactForm.find('#message').val(),
                    token : $contactForm.find('#recaptcha').val()
                }
                
                console.log(postData);
            
                /* post to admin-ajax.php */
                sendAjax(postData, $contactForm, $errorNotice, function(res, postData) {
                    if ( res.success === true ) {
                        $submitBtn
                            .addClass('success')
                            .attr("disabled", true)
                            .html(ContactFormLocalizedData.sentMessageText)
                            ;
                    }
                    else {
                        console.log(res);
                        $errorNotice.removeClass('hidden');
                    }
                });
                
            });
        });
    });
}